import React from "react";
import { Box, Grid2, Typography } from "@mui/material";
import { TileTypes } from "../../../types/tileType";
import FormCheckbox from "../../forms/FormCheckbox";
import FormTextField from "../../forms/FormTextField";
import { Control } from "react-hook-form";
import Tile from "../../../types/tile";
import { JSX } from "react/jsx-runtime";
import Settings from "../../../types/settings";

interface Props {
  control: Control<Tile, any>;
  formValues: Tile;
  settings: Settings;
  loadWithSkeleton: (
    element: React.ReactNode
  ) =>
    | string
    | number
    | boolean
    | Iterable<React.ReactNode>
    | JSX.Element
    | null
    | undefined;
}

const AlertsForm: React.FC<Props> = (props) => {
  const { control, formValues, settings, loadWithSkeleton } = props;

  return (
    <>
      {((formValues.dataType?.id! >= 7 &&
        formValues.type?.id === TileTypes.Circle) ||
        !!formValues.type?.hasThreshold) && (
        <>
          <Box display="flex" flexDirection="row" width="100%" mt={2}>
            <Typography fontWeight="bold">Alerts</Typography>
          </Box>
          {formValues.dataType?.id! >= 7 &&
            formValues.type?.id === TileTypes.Circle &&
            (settings?.notificationSettings?.emailNotifications ||
              settings?.notificationSettings?.siteNotifications ||
              settings?.notificationSettings?.svNotifications) && (
              <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                {loadWithSkeleton(
                  <FormCheckbox
                    control={control}
                    fieldName="alerts.offline.enabled"
                    label="Alert when offline number increases?"
                    disabled={
                      formValues.dataType?.id! < 7 ||
                      formValues.type?.id !== TileTypes.Circle
                    }
                  />
                )}
              </Grid2>
            )}
          {!!formValues.type?.hasThreshold &&
            (settings?.notificationSettings?.emailNotifications ||
              settings?.notificationSettings?.siteNotifications ||
              settings?.notificationSettings?.svNotifications) && (
              <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                {loadWithSkeleton(
                  <FormCheckbox
                    control={control}
                    fieldName="alerts.threshold.enabled"
                    label="Alert when number goes above threshold?"
                    disabled={!formValues.type?.hasThreshold}
                  />
                )}
              </Grid2>
            )}
          {!!formValues.type?.hasThreshold && (
            <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
              {loadWithSkeleton(
                <FormTextField
                  control={control}
                  fieldName="threshold"
                  label="Threshold"
                  type="number"
                  required={!!formValues?.alerts?.threshold?.enabled}
                  disabled={!formValues.type?.hasThreshold}
                />
              )}
            </Grid2>
          )}
        </>
      )}
    </>
  );
};

export default AlertsForm;
